import './LoadingBar.css'; 

const LoadingBar = ({ text = "Loading..." }) => {
  return (
    <div className="loading-container">
      <div className="loading-bar-wrapper">
        <div className="loading-bar">
          <div className="loading-bar-fill"></div>
        </div>
        <p className="loading-text">{text}</p>
      </div>
    </div>
  );
};

export default LoadingBar;